import { createRpcClientV2 } from 'rpc-client-utils';
import { createChirpFetch, loadBalancers, chirpGateways } from 'chirp-fetch';
import appAuthApiClient from 'hub-http/clients/apiClient';
export function createDefaultChirpClient() {
  const chirpFetch = createChirpFetch({
    loadBalancer: loadBalancers.APP,
    gateway: chirpGateways.APP,
    useLongLivedLb: true
  });
  return createRpcClientV2({
    hubHttpClient: appAuthApiClient,
    fetchClient: chirpFetch
  });
}